import IFilterService = angular.IFilterService;
import {UrlService} from "../../../../services/urlService";

class ArticlesController {
    searchResult:Array<any>;
    defaultSearchParams={pageSize:100, pageNo: 0, sort:"earliestPoDeliveryDate|asc"};
    activeSearchParams = Object.assign({},this.defaultSearchParams);

    searchDefinition ={
        fields:[
            {title:'Vare', name: 'articleNameOrId', type:'text'},
            {title:'Varegruppe', name: 'articleGroup', type:'number'},
            {title:'Leverandør', name: 'supplierNameOrId', type:'text'},
            {title:'Behov', name: 'articlesWithShortageOnly', type:'checkbox'}
        ],
        searchFunction:(paramsWithFormattedDates)=> this.articlesSearch(paramsWithFormattedDates),
        searchParams: Object.assign({},this.defaultSearchParams),
        preDefinedSearches:[
            {title: "Kan ikke leveres", ligature: "report_problem", func:()=>this.getArticlesWithShortageOnly(), name:'articlesShortageOnly'},
            {title: "Kan leveres før", ligature: "flight_takeoff", func:()=>this.getArticlesEarlierOnly(), name:'articlesEarlierOnly'}
        ]
    };

    toolbarheaderDefinition = {
        isTable: true,
        toolbarHeading: "Søk etter varer",
        buttons: [
            {func: () => { this.searchDefinition.searchParams = Object.assign({},this.defaultSearchParams)},   tooltip: "Slett søkedata", materialicon: "delete_sweep"},
        ]
    };

    iconColumn = {title:'', name: ''};
    tableDefinition = {
        columns:[
            {title:'Vare', name: 'articleNo', type:'number'},
            {title:'Leverandør', name: 'supplierName', hasReducedSize:true},
            {title:'# ordre', name: 'orderlineCount', hasReducedSize:true, noOrderBy:true},
            {title:'I ordre', name: 'qtySales', hasReducedSize:true, noOrderBy:true},
            {title:'Lager', name: 'qtyInStock', hasReducedSize:true, noOrderBy:true},
            this.iconColumn,
            {title:'Behov', name: 'quantityNeeded', hasReducedSize:true, noOrderBy:true},
            {title:'I bestilling', name: 'qtyPurchase', hasReducedSize:true, noOrderBy:true},
        ],
        settings:{
            onPaginate: (pageInfo)=> this.changePage(pageInfo),
            onOrderBy: (columnName)=> this.orderBy(columnName),
            totalElements: null,
            promise: null
        }
    };

    constructor(private toastService, private $filter: IFilterService, private Articles, private urlService:UrlService, private $location){}
    
    changePage(pageInfo){
        this.activeSearchParams.pageNo = pageInfo.page -1;
        this.activeSearchParams.pageSize = pageInfo.limit;
        this.$location.search(this.activeSearchParams);
    }

    orderBy(columnName){
        var descending = columnName[0] === '-';
        columnName = descending ? columnName.slice(1, columnName.length) : columnName;
        var orderDirection = descending ? "desc" : "asc";

        this.activeSearchParams.sort = columnName + "|" + orderDirection;
        this.$location.search(this.activeSearchParams);
    }
    
    articlesSearch(paramsWithFormattedDates){
        this.activeSearchParams = paramsWithFormattedDates;
        this.tableDefinition.settings.promise = this.Articles.search(paramsWithFormattedDates,{}).$promise.then(
            (results)=>{
                if(results.content.length === 0){
                    this.toastService.showSimpleToast("Søket gav ingen resultater", 2000);
                    this.searchResult = null;
                }
                else{
                    this.tableDefinition.settings.totalElements = results.totalElements;
                    this.searchResult = results.content.map(article => {
                        return Object.assign({},article, {quantityNeeded:this.getQuantityNeeded(article)})
                    });
                }
            },
            (error)=>this.toastService.parseError(error)
        );
    }
    getQuantityNeeded(article){
        var quantityNeeded = article.qtyInStock - article.qtySales + article.qtyPurchase;
        return quantityNeeded < 0
            ? quantityNeeded * -1
            : 0;
    }
    getArticlesWithShortageOnly	(){
        var params ={
            articlesWithShortageOnly: true,
            pageNo:  this.searchDefinition.searchParams.pageNo,
            pageSize: this.searchDefinition.searchParams.pageSize,
            sort: "earliestPoDeliveryDate|asc"
        };
        this.articlesSearch(params);
    }
    getArticlesEarlierOnly(){
        var params ={
            articlesEarlierOnly: true,
            pageNo:  this.searchDefinition.searchParams.pageNo,
            pageSize: this.searchDefinition.searchParams.pageSize,
            sort: "earliestPoDeliveryDate|asc"
        };
        this.articlesSearch(params);
    }

}

class ArticlesOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcArticlesController";
    public template: any = require('./articles.html');

}

rkcApp.controller("rkcArticlesController", ['toastService', '$filter', 'Articles','urlService','$location', function( toastService, $filter, Articles, urlService, $location){
    return new ArticlesController(toastService, $filter, Articles, urlService, $location);
}])
    .component("rkcArticles", new ArticlesOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/articles/articles.ts
 **/